"use client";
import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { INVALID_PROPS_ERROR, COMPONENT_NAME } from "./constants.js";
import { boxStyles } from "./styles.js";
import { InteractiveView } from "./view.interactive.js";
import { StandardView } from "./view.standard.js";
import { getDataTestId } from "../../Util/index.js";
const Rating = ({
  displayAvgRatingAsText = true,
  displayReviewCount = true,
  onRatingClick,
  ratingClickActionName,
  reviewCount = null,
  value,
  ariaLabel,
  uniqueId,
  displayVariant = "full",
  size,
  fillColor,
  strokeWidth,
  strokeColor,
  overlayColor,
  showReviewCountText,
  staticUniqueId = false,
  emptyReviewText = ""
}) => {
  if (isNaN(value)) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  const dataTestId = staticUniqueId && uniqueId ? `${uniqueId}` : getDataTestId(COMPONENT_NAME, uniqueId);
  return /* @__PURE__ */ jsx(Box, { sx: boxStyles, "data-testid": dataTestId, children: onRatingClick ? /* @__PURE__ */ jsx(
    InteractiveView,
    {
      displayAvgRatingAsText,
      displayReviewCount,
      onRatingClick,
      ratingClickActionName,
      reviewCount,
      value,
      ariaLabel,
      displayVariant,
      size,
      emptyReviewText
    }
  ) : /* @__PURE__ */ jsx(
    StandardView,
    {
      displayAvgRatingAsText,
      displayReviewCount,
      reviewCount,
      value,
      ariaLabel,
      displayVariant,
      size,
      fillColor,
      strokeColor,
      strokeWidth,
      overlayColor,
      showReviewCountText,
      emptyReviewText
    }
  ) });
};
Rating.displayName = COMPONENT_NAME;
export {
  Rating
};
